import { useToast } from "@chakra-ui/react";
import {
  ExpressCheckoutElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";

const Checkout = (props: {
  card_id: number | null;
  price: number | null;
  ext_file: string | null;
  art: string | null;
  issued: string | null;
  uuid: string | null;
  image: string | null;
  setIsLoading: (arg0: boolean) => any;
}) => {
  const stripe = useStripe();
  const card_id = props.card_id;
  const stripeEndpoint = process.env.NEXT_PUBLIC_STRIPE_ENDPOINT;
  const options = {
    emailRequired: true,
  };
  const [clientSecret, setClientSecret] = useState("");

  const elements = useElements();

  const toast = useToast();

  const paymentIntent = useCallback(async () => {
    if (stripeEndpoint) {
      const response = await axios.post(stripeEndpoint, {
        amount: 299,
        automatic_payment_methods: {
          enabled: true,
        },
        currency: "usd",
        card_id: card_id,
      });
      const clientSecret = response.data.client_secret;
      setClientSecret(clientSecret);
    }
  }, [stripeEndpoint, card_id]);

  useEffect(() => {
    paymentIntent();
  }, [paymentIntent]);

  const onConfirm = async () => {
    if (!stripe || !elements) {
      return;
    }
    const { error } = await stripe.confirmPayment({
      elements: elements,
      clientSecret: clientSecret,
      confirmParams: {
        return_url: `${window.location.origin}/cards/${props.uuid}`,
      },
      // Uncomment below if you only want redirect for redirect-based payments.
      redirect: "if_required",
    });

    if (error) {
      // This point is reached only if there's an immediate error when confirming the payment. Show the error to your customer (for example, payment details incomplete).
    } else {
      // Your customer will be redirected to your `return_url`.
      toast({
        title: "Success",
        description: "Your songcard will be delivered to your inbox shortly!",
        status: "success",
        duration: 9000,
        isClosable: true,
        colorScheme: "green",
      });
    }
  };

  return (
    <div>
      <ExpressCheckoutElement
        options={options}
        onConfirm={onConfirm}
        onReady={() => props.setIsLoading(false)}
      />
    </div>
  );
};

export default Checkout;
